export default __webpack_public_path__ + "static/media/gear_icon.3c643113.svg";